import { EditUserComponent } from './edit-user/edit-user.component';
import { users, UserviewModel } from './../../service/sector.model';
import { ConfirmdeleteComponent } from './../../service/confirmdelete/confirmdelete.component';
// import { DialogService } from 'ng2-bootstrap-modal';
import { ManageService } from '../../service/manage.service';
import { DBConnectorService } from './../../service/test.service';
import { Component, OnInit } from '@angular/core';
import { LoggedInGuard } from '../../authentication/logged-in.guard';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})
export class UsersComponent implements OnInit {
  bsModalRef: BsModalRef;
  public User = new users;
  UserName: string;
  UserRole: string;
  SectorNameList = [];
  userlist = [];
  result:any = {};
  sectorlist:any = [];
  userdata = new UserviewModel;

  constructor(private dbconnectorservice: DBConnectorService,
    private manage: ManageService,
    private _dialogService: BsModalService,
    private loggedInGuard: LoggedInGuard) {
    this.User.IsAdmin = false;
  }

  getuserlist() {
    if (this.loggedInGuard.isSessionValid()) {
      this.dbconnectorservice.getallusers()
        .subscribe(res => {
          this.userlist = res;
        });
    }
  }

  getsectorlist() {
    if (this.loggedInGuard.isSessionValid()) {
      this.dbconnectorservice.getsectors()
        .subscribe(res => this.sectorlist = res);
    }
  }

  UserCreate() {
    if (this.loggedInGuard.isSessionValid()) {
      this.User.UserName = this.UserName;
      this.User.Roleid = this.UserRole;
      this.userdata.User = this.User;
      this.userdata.User.Password = '1234Test';
      this.userdata.SectorList = this.SectorNameList;
      // if (this.userdata.User.samAccountName == null) {
      //   alert('Account Name is empty . Please search the user. ');
      // } else {
      this.manage.createUser(this.userdata)
        .subscribe(
          (data) => {
            this.result = data;
            console.log(this.result);
            this.getuserlist();
          });
      // }
    }
  }

  showConfirm(use: users) {    
    this.bsModalRef = this._dialogService.show(ConfirmdeleteComponent);
    this.bsModalRef.content.event.subscribe(isConfirmed => {
      if(isConfirmed) 
        this.UserDelete(use)
    })
    // const disposable = this.dialogService.addDialog(ConfirmdeleteComponent, {
    //   // title: 'Confirm title',
    //   // message: 'Confirm message'
    // })
    //   .subscribe((isConfirmed) => {
    //     // We get dialog result
    //     if (isConfirmed) {
    //       this.UserDelete(use);
    //     } else {
    //       // alert('declined');
    //     }
    //   });
    // We can close dialog calling disposable.unsubscribe();
    // If dialog was not closed manually close it by timeout
    // setTimeout(() => {
    //   disposable.unsubscribe();
    // }, 10000);
  }

  UserDelete(use: users) {
    if (this.loggedInGuard.isSessionValid()) {
      this.manage.deleteUser(use)
        .subscribe(
          (data) => {
            this.result = data;
            console.log(this.result);
            this.getuserlist();
          });
    }
  }

  showEdit(use: users) {
    const initialState = {
      User1: use,
      sectorlist: this.sectorlist
    };
    this.bsModalRef = this._dialogService.show(EditUserComponent, { initialState })
    this.bsModalRef.content.event.subscribe(isConfirmed => {
      if(isConfirmed)
        this.getuserlist()
    })
    // const disposable = this.dialogService.addDialog(EditUserComponent, {
    //   User1: use,
    //   sectorlist: this.sectorlist
    //   // title: 'Confirm title',
    //   // message: 'Confirm message'
    // })
    //   .subscribe((isConfirmed) => {
    //     // We get dialog result
    //     if (isConfirmed) {
    //       this.getuserlist();
    //     } else {
    //       // alert('declined');
    //     }
    //   });
    // We can close dialog calling disposable.unsubscribe();
    // If dialog was not closed manually close it by timeout
    // setTimeout(() => {
    //   disposable.unsubscribe();
    // }, 10000);
  }

  GetUserDetails(use: users) {
    if (this.loggedInGuard.isSessionValid()) {
      this.userdata.User = this.User;
      this.manage.GetUserDetails(this.userdata)
        .subscribe(
          (data) => {
            this.result = data;
            if (data.samAccountName === '') {
              alert('User does not exist');
            } else {
              this.User.samAccountName = data.samAccountName;
            }
            console.log(this.result);

          });
    } else { }
  }

  GetRole(roleid: number) {
    let roleName: String;
    if (roleid != null) {
      switch (roleid) {
        case 1:
          roleName = 'Super Admin';
          break;
        case 2:
          roleName = 'Admin';
          break;
        case 3:
          roleName = 'User';
          break;
        default:
          roleName = '';
          break;
      }
    } else {
      roleName = '';
    }
    return roleName;
  }
  ngOnInit() {
    this.getuserlist();
    this.getsectorlist();
    this.User.Roleid = '1';
  }

}
